(() => {
  'use strict';
  const api = window.FTLAudienceEvents;
  if (!api || window.FTLFunnelEvents) return;
  window.FTLFunnelEvents = {version: '2.0.0'};
  const product = () => api.productId ? {product_ids: [String(api.productId)]} : {};
  const emit = (name, data = {}) => api.track(name, {...product(), ...data});
  const digits = value => /^\d+$/.test(String(value || '')) ? String(value) : null;
  const position = node => {
    if (node.closest('[data-ftl-mobile-purchase]')) return 'mobile_purchase_bar';
    if (node.closest('header')) return 'header';
    if (node.closest('footer')) return 'footer';
    if (node.closest('[data-ftl-accessories]')) return 'accessories';
    if (node.closest('form[action*="/cart/add"]')) return 'product_form';
    return 'page_content';
  };
  document.addEventListener('click', event => {
    if (!event.isTrusted || !api.allowed()) return;
    const node = event.target.closest?.('a,button,input[type="submit"],summary');
    if (!node || node.disabled || node.getAttribute('aria-disabled') === 'true') return;
    if (node.matches('[data-media-thumb]')) {
      if (node.getAttribute('aria-current') !== 'true') emit('MediaSelect', {media_id: digits(node.getAttribute('data-media-thumb')) || 'unknown'});
    } else if (node.matches('[data-ftl-accessories-toggle]')) {
      const expanded = node.getAttribute('aria-expanded') !== 'true';
      emit('AccessoryExpand', {expanded});
    } else if (node.matches('.dji-product__accordion > summary')) {
      const detail = node.parentElement;
      if (!detail.open) emit('DetailExpand', {detail_index: Array.from(detail.parentElement.children).indexOf(detail) + 1});
    } else if (node.matches('[name="checkout"]')) {
      emit('CheckoutClick', {placement: position(node)});
    } else if (node.matches('[data-add-button],[data-ftl-purchase-link],button[name="add"]')) {
      emit('CtaClick', {cta_type: 'add_to_cart', placement: position(node)});
    } else if (node.matches('a[href]')) {
      let url;
      try { url = new URL(node.href, location.href); } catch (_) { return; }
      if (url.origin !== location.origin) return;
      if (/\/(?:checkouts?|checkout)\b/.test(url.pathname)) emit('CheckoutClick', {placement: position(node)});
      else if (/\/products\/[^/]+/.test(url.pathname)) {
        const handle = url.pathname.match(/\/products\/([^/]+)/)[1];
        emit('CtaClick', {cta_type: 'product_link', placement: position(node), destination_product: /^[a-z0-9-]{1,80}$/i.test(handle) ? handle : 'product'});
      }
    }
  }, true);
  document.addEventListener('change', event => {
    if (!event.isTrusted || !api.allowed()) return;
    const node = event.target;
    if (node.matches?.('[data-accessory-check],[data-accessory-variant-select]')) {
      const row = node.closest('[data-accessory-row]');
      const variant = digits(row?.querySelector('[data-accessory-variant-select]')?.value || row?.getAttribute('data-variant-id'));
      emit('AccessorySelect', {accessory_variant_id: variant || 'unknown', selected: !!row?.querySelector('[data-accessory-check]')?.checked});
    } else if (node.matches?.('select[name="id"],input[type="radio"][name="id"],.dji-product__variant-radio')) {
      const id = digits(node.value);
      if (id) emit('VariantSelect', {variant_id: id});
    }
  }, true);
  document.addEventListener('submit', event => {
    if (!event.isTrusted || !api.allowed()) return;
    const form = event.target;
    let path;
    try { path = new URL(form.action, location.href).pathname; } catch (_) { return; }
    if (/\/search\/?$/.test(path)) emit('SearchSubmit', {search_type: 'site_search'});
  }, true);
  let scrollPending = false;
  const depths = new Set();
  document.addEventListener('scroll', event => {
    if (scrollPending || !event.isTrusted || !api.allowed()) return;
    scrollPending = true;
    requestAnimationFrame(() => {
      scrollPending = false;
      if (!api.allowed() || document.visibilityState !== 'visible' || window.scrollY <= 0) return;
      const total = document.documentElement.scrollHeight - window.innerHeight;
      if (total <= 0) return;
      const percent = Math.min(100, window.scrollY / total * 100);
      [25, 50, 75, 90].forEach(depth => {
        if (percent >= depth && !depths.has(depth)) { depths.add(depth); emit('ScrollDepth', {percent_scrolled: depth}); }
      });
    });
  }, {passive: true});
  const videoStates = new WeakMap();
  const videoState = video => {
    let state = videoStates.get(video);
    if (!state) { state = {started: false, depths: new Set(), index: Array.from(document.querySelectorAll('video')).indexOf(video) + 1}; videoStates.set(video, state); }
    return state;
  };
  const videoActive = video => {
    if (!api.allowed() || document.visibilityState !== 'visible' || video.paused) return false;
    const rect = video.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0 && rect.top < window.innerHeight && rect.bottom > 0;
  };
  document.addEventListener('timeupdate', event => {
    const video = event.target;
    if (video.tagName !== 'VIDEO' || !videoActive(video) || video.currentTime <= 0) return;
    const state = videoState(video);
    if (!state.started) {
      state.started = true;
      state.previousTime = video.currentTime;
      state.watched = 0;
      emit('VideoStart', {video_index: state.index, autoplay: video.autoplay, video_provider: 'native'});
    }
    const delta = video.currentTime - state.previousTime;
    state.previousTime = video.currentTime;
    if (delta > 0 && delta < 2 && !video.seeking) state.watched += delta;
    if (!Number.isFinite(video.duration) || video.duration <= 0) return;
    [25, 50, 75, 90].forEach(depth => {
      if (state.watched / video.duration * 100 >= depth && !state.depths.has(depth)) {
        state.depths.add(depth);
        emit('VideoProgress', {video_index: state.index, video_percent: depth, video_provider: 'native'});
      }
    });
  }, true);
  const sections = new Map();
  const candidates = [
    ['[data-ftl-accessories]', 'accessories'],
    ['.dji-product__accordions', 'product_details'],
    ['.jdgm-review-widget,.loox-reviews-default,#shopify-product-reviews', 'reviews']
  ];
  const scan = () => candidates.forEach(([selector, type]) => document.querySelectorAll(selector).forEach(node => {
    if (!sections.has(node)) sections.set(node, {type, since: 0, done: false});
  }));
  scan();
  setInterval(() => {
    if (!api.allowed() || document.visibilityState !== 'visible') {
      for (const item of sections.values()) item.since = 0;
      return;
    }
    for (const [node, item] of sections) {
      if (!node.isConnected) { sections.delete(node); continue; }
      if (item.done) continue;
      const rect = node.getBoundingClientRect();
      const visible = rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight && Math.min(rect.bottom, window.innerHeight) - Math.max(0, rect.top) >= Math.min(rect.height * 0.5, window.innerHeight * 0.5);
      if (!visible) { item.since = 0; continue; }
      if (!item.since) item.since = Date.now();
      else if (Date.now() - item.since >= 1000) { item.done = true; emit('SectionView', {section_type: item.type}); }
    }
  }, 1000);
  document.addEventListener('shopify:section:load', scan);
  window.addEventListener('load', scan, {once: true});
  document.addEventListener('visitorConsentCollected', () => {
    if (!api.allowed()) {
      depths.clear();
      for (const item of sections.values()) { item.since = 0; item.done = false; }
      document.querySelectorAll('video').forEach(video => videoStates.delete(video));
    }
  });
})();
